// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"633":"7d330bd7","986":"9bd5e15b"}[chunkId] + ".css";
};